/* eslint-disable import/no-unassigned-import */
import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import { name, version } from '../../package.json';

assertPackageVersion(name, version);

import '../events';

export { SDK_ERRORS as WC_ERRORS } from '@walletconnect/utils';

export { appendWalletConnectUriToDeepLink } from '../appendWalletConnectUriToDeepLink';
export { SessionClosedUnexpectedlyError } from '../errors/SessionClosedUnexpectedlyError';
export { isWalletConnectWalletProvider } from '../isWalletConnectWalletProvider';
export type {
  WalletConnectConnectionResult,
  WalletConnectWalletProvider,
} from '../walletConnectWalletProvider.types';
